import { Storage, Drivers } from "@ionic/storage";
import CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';
import { KeyValueStorage } from "./types";

export const createIonicStorage = async (storageName: string): Promise<KeyValueStorage> => {

    const storage = new Storage({ name: storageName, driverOrder: [CordovaSQLiteDriver._driver, Drivers.IndexedDB, Drivers.LocalStorage] });
    await storage.defineDriver(CordovaSQLiteDriver);
    await storage.create();

    return {
        get: async (key: string) => {
            return await storage.get(key);
        },
        set: async (key: string, value: string) => {
            return await storage.set(key, value);
        },
        remove: async (key: string) => {
            return await storage.remove(key);
        },
        clear: async () => {
            return await storage.clear();
        }
    };
};